import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getKindLikeValueSafely,
  getNonEmptyString,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { DropdownEditor } from './select-edit';
import { DropdownView } from './select-view';

export const DROPDOWN_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'dropdown',
  editable: true,
  View: DropdownView,
  Editor: DropdownEditor,
  decode: (raw) => ({ kind: 'dropdown', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'dropdown'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'dropdown'),
};
